import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcdConnectEmojiNeutral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 38C29.4932 38 38 29.4932 38 19C38 8.50677 29.4932 0 19 0C8.50677 0 0 8.50677 0 19C0 29.4932 8.50677 38 19 38Z",
			fill: "#1DBADF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0653 24.7062C10.0653 25.7699 8.90689 26.6321 7.47643 26.6321C6.04598 26.6321 4.8851 25.7699 4.8851 24.7062C4.8851 23.6424 6.04598 22.7803 7.47643 22.7803C8.90689 22.7803 10.0653 23.6424 10.0653 24.7062Z",
			fill: "#FF2180"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.7874 24.7062C32.7874 25.7699 31.629 26.6321 30.1985 26.6321C28.7681 26.6321 27.6072 25.7699 27.6072 24.7062C27.6072 23.6424 28.7681 22.7803 30.1985 22.7803C31.629 22.7803 32.7874 23.6424 32.7874 24.7062Z",
			fill: "#FF2180"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8572 16.8667C13.4516 16.4539 13.0461 16.0434 12.6405 15.6306C12.315 15.3003 11.7905 15.4776 11.6545 15.8904C11.2125 17.2262 9.97143 18.1417 8.57012 18.1903C7.15667 18.2389 5.82821 17.333 5.34006 16.007C5.18463 15.582 4.70134 15.4338 4.35405 15.7471C4.09661 15.9778 3.90961 16.2766 3.70803 16.5559C3.5016 16.84 3.29517 17.1217 3.08631 17.4059C2.89688 17.6657 3.04259 18.064 3.2976 18.2146C3.59632 18.3895 3.91689 18.2607 4.1039 18.0033C4.29819 17.7362 4.49248 17.469 4.68919 17.2019L5.03163 16.7331C5.06077 16.6919 5.09234 16.6506 5.12149 16.6093C4.9782 16.806 5.11663 16.6481 5.18706 16.5826C4.8592 16.4951 4.52891 16.4077 4.20104 16.3227C4.8762 18.1636 6.59323 19.3949 8.56769 19.373C10.5057 19.3512 12.1888 18.0203 12.7911 16.2061C12.4632 16.2936 12.1329 16.381 11.805 16.466C12.2106 16.8789 12.6162 17.2917 13.0218 17.7022C13.5561 18.2462 14.3915 17.4107 13.8572 16.8667Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54953 18.4186C6.32366 18.8825 6.0978 19.3464 5.87194 19.8127C5.73108 20.1017 5.7918 20.449 6.08323 20.619C6.34552 20.772 6.7511 20.6967 6.89196 20.4077C7.11782 19.9438 7.34368 19.4799 7.56954 19.0136C7.7104 18.7246 7.64969 18.3774 7.35825 18.2073C7.09596 18.0543 6.69039 18.1296 6.55195 18.4186",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.6217 18.8434C9.80142 19.3267 9.98114 19.8124 10.1609 20.2957C10.2726 20.5969 10.5567 20.7984 10.887 20.7086C11.176 20.6284 11.4116 20.2836 11.2999 19.9824C11.1202 19.4991 10.9404 19.0134 10.7607 18.5301C10.649 18.229 10.3649 18.0274 10.0346 18.1172C9.74556 18.1974 9.50999 18.5423 9.6217 18.8434Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1717 16.8667C24.5772 16.4539 24.9828 16.0434 25.3884 15.6306C25.7138 15.3003 26.2384 15.4776 26.3744 15.8904C26.8164 17.2262 28.0574 18.1417 29.4587 18.1903C30.8722 18.2389 32.2007 17.333 32.6888 16.007C32.8442 15.582 33.3275 15.4338 33.6748 15.7471C33.9323 15.9778 34.1193 16.2766 34.3208 16.5559C34.5273 16.84 34.7337 17.1217 34.9426 17.4059C35.132 17.6657 34.9863 18.064 34.7313 18.2146C34.4326 18.3895 34.112 18.2607 33.925 18.0033C33.7307 17.7362 33.5364 17.469 33.3397 17.2019L32.9972 16.7331C32.9681 16.6919 32.9365 16.6506 32.9074 16.6093C33.0507 16.806 32.9122 16.6481 32.8418 16.5826C33.1697 16.4951 33.5 16.4077 33.8278 16.3227C33.1527 18.1636 31.4356 19.3949 29.4612 19.373C27.5231 19.3512 25.8401 18.0203 25.2378 16.2061C25.5657 16.2936 25.896 16.381 26.2238 16.466C25.8183 16.8789 25.4127 17.2917 25.0071 17.7022C24.4728 18.2462 23.6374 17.4107 24.1717 16.8667Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4793 18.4186C31.7052 18.8825 31.9311 19.3464 32.1569 19.8127C32.2978 20.1017 32.2371 20.449 31.9456 20.619C31.6833 20.772 31.2778 20.6967 31.1369 20.4077C30.911 19.9438 30.6852 19.4799 30.4593 19.0136C30.3185 18.7246 30.3792 18.3774 30.6706 18.2073C30.9329 18.0543 31.3385 18.1296 31.4769 18.4186",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.4072 18.8434C28.2274 19.3267 28.0477 19.8124 27.868 20.2957C27.7563 20.5969 27.4721 20.7984 27.1419 20.7086C26.8529 20.6284 26.6173 20.2836 26.729 19.9824C26.9087 19.4991 27.0884 19.0134 27.2681 18.5301C27.3799 18.229 27.664 18.0274 27.9943 18.1172C28.2833 18.1974 28.5189 18.5423 28.4072 18.8434Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15,
			y: 24,
			width: 8,
			height: 1,
			rx: .5,
			fill: "#1C1C1C"
		})
	]
});
export default SvgEcdConnectEmojiNeutral;
